import { render, staticRenderFns } from "./CannedResponse.vue?vue&type=template&id=7efd345c&scoped=true&"
import script from "./CannedResponse.vue?vue&type=script&lang=js&"
export * from "./CannedResponse.vue?vue&type=script&lang=js&"
import style0 from "./CannedResponse.vue?vue&type=style&index=0&id=7efd345c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd345c",
  null
  
)

export default component.exports